// extracted by mini-css-extract-plugin
module.exports = {"disclosure":"disclosure-1-t6S"};